module.exports = require('react-dom/lib/ReactTestUtils');


//////////////////
// WEBPACK FOOTER
// ./~/react-addons-test-utils/index.js
// module id = 2047
// module chunks = 2